import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ActivityModelCreatePayload } from "../repositories/activitiesRepository";
import { activitiesRepository } from "../repositories/activitiesRepository";

/**
 * Mutation hook to create a new activity model (template)
 */
export const useCreateActivityModelMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["activities", "models", "create"],
    mutationFn: (payload: ActivityModelCreatePayload) =>
      activitiesRepository.createActivityModel(payload),
    onSuccess: (_response, variables) => {
      // Invalidate models and activities queries to refresh lists
      queryClient.invalidateQueries({ queryKey: ["activities", "models"] });
      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey;
          if (!Array.isArray(key)) return false;

          return Boolean(
            (variables.terreiroId &&
              key[0] === "terreiro" &&
              key[1] === variables.terreiroId &&
              key[2] === "activities") ||
            (variables.mediumId &&
              key[0] === "activity" &&
              key[1] === "medium" &&
              key[2] === variables.mediumId)
          );
        },
      });
    },
    retry: 0,
  });
};
